import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SignaturePadModule } from 'angular2-signaturepad';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { FormWidgetSignatureComponent } from '@bcm-work-flows/@form-widgets/core/signature/form-widget-signature.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
    declarations: [FormWidgetSignatureComponent],
    imports: [
        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatCheckboxModule,

        SignaturePadModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatInputModule,
        MatButtonToggleModule,
        MatRadioModule
    ],
    exports: [FormWidgetSignatureComponent]
})
export class FormWidgetSignatureModule {
    
}
